
<div *ngIf="isEmpty" class="empty noselect">
  <mat-icon>add</mat-icon>
  <span>{{ 'New procedure' | translate }}</span>
</div>

<app-grid-element
  [title]="title"
  [subtitleHTML]="('Tasks' | translate) + ': <strong>'  + task + '</strong>'"
  previewImage="assets/img/procedure/procedure.png"
  [previewOverlay]="true"
  [bottomIcons]="getAuthoringIcons()"
  [canEdit]="true"
  [canRemove]="canDelete"
  (onEdit)="onEdit.next()"
  (onRemove)="onRemove.next()"
></app-grid-element>
